const IconCircuit = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.0001 1.04163C12.8081 1.04163 11.0417 2.83482 11.0417 5.03358C11.0417 6.25215 11.6031 7.14866 12.2467 7.88304C12.5284 8.20455 12.8394 8.50963 13.1312 8.79596L13.2398 8.90263C13.5702 9.22754 13.8729 9.53263 14.1317 9.85404C14.5673 10.3951 15.4217 10.4146 15.8746 9.87229C16.1418 9.55221 16.4494 9.24454 16.7818 8.91454L16.8184 8.87821C17.1331 8.56588 17.4694 8.23211 17.7726 7.87737C18.4084 7.13329 18.9584 6.22923 18.9584 5.03358C18.9584 2.83482 17.1921 1.04163 15.0001 1.04163ZM15.0001 3.54163C14.1947 3.54163 13.5417 4.19454 13.5417 4.99996C13.5417 5.80538 14.1947 6.45829 15.0001 6.45829H15.0076C15.813 6.45829 16.4659 5.80538 16.4659 4.99996C16.4659 4.19454 15.813 3.54163 15.0076 3.54163H15.0001Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.04175 15.8333C1.04175 14.1074 2.44086 12.7083 4.16675 12.7083C5.89264 12.7083 7.29175 14.1074 7.29175 15.8333C7.29175 17.5592 5.89264 18.9583 4.16675 18.9583C2.44086 18.9583 1.04175 17.5592 1.04175 15.8333Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.16675 8.33329C4.16675 6.37645 5.97082 4.99996 7.91675 4.99996H9.16675C9.627 4.99996 10.0001 5.37306 10.0001 5.83329C10.0001 6.29353 9.627 6.66663 9.16675 6.66663H7.91675C6.64101 6.66663 5.83342 7.52871 5.83342 8.33329C5.83342 9.13788 6.64101 9.99996 7.91675 9.99996H10.4167C12.3627 9.99996 14.1667 11.3765 14.1667 13.3333C14.1667 15.2901 12.3627 16.6666 10.4167 16.6666H9.16675C8.7065 16.6666 8.33342 16.2935 8.33342 15.8333C8.33342 15.373 8.7065 15 9.16675 15H10.4167C11.6925 15 12.5001 14.1379 12.5001 13.3333C12.5001 12.5287 11.6925 11.6666 10.4167 11.6666H7.91675C5.97082 11.6666 4.16675 10.2901 4.16675 8.33329Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconCircuit;
